<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <b-row>
          <b-col md="8">
            <h2>{{$t('message.Subject_name')}}</h2>
          </b-col>
          <b-col md="4">
            <b-button
                size="lg"
                variant="outline-primary"
                style="margin-left: 70px"
                @click="handleAdd"
            ><i class='bx bx-plus'>{{$t('message.Add')}}</i>
            </b-button>
          </b-col>
        </b-row>
        <div>
          <b-card
              class="mt-1"
              style="width: 90%; margin: 0 auto;"
          >
            <b-table
                responsive
                striped
                hover
                :items="subjects"
                :fields="fields">
              <template #cell(id)="data">
                <span class="text-md text-primary"> {{ (data.index + 1) }}</span>
              </template>
              <template #cell(action)="data">
                <b-button
                    variant="warning"
                    size="sm"
                    @click="handleEdit(data.item.id)"
                ><i class='bx bx-pencil'></i>
                </b-button>
                <b-button
                    class="ml-1"
                    style="margin-left: 10px"
                    size="sm"
                    variant="danger"
                    @click="handleDelete(data.item.id)"
                ><i class='bx bx-trash' ></i>
                </b-button>
              </template>
            </b-table>
          </b-card>
        </div>
        <b-modal
            v-model="activeModal"
            hide-footer
            id="modal-center"
            centered
            :title="$t('message.Subject_name')">
        <SubjectModal
            :id="id"
            :activeModal="activeModal"
            @closeModal="modalClose" />
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {getSubjects, deleteSubject} from "../../../../../../api/subject";
import SubjectModal from "./SubjectModal";
import Swal from "sweetalert2";
import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";


export default {
  name: "Index",
  components: {
    HorizontalTopbarInside,
    SubjectModal,
    SideBar
  },
  data() {
    return {
      id: null,
      activeModal: false,
      isMenuCondensed: false,
      subjects: [],
      fields: [
        {
          key: 'id',
          label: this.$t('message.Id'),
        },
        {
          key:'subject',
          label: this.$t('message.Subject')
        },
        {
          key: 'action',
          label: this.$t('message.Action')
        }
      ]
    };
  },
  computed: {
    ...layoutComputed,
  },
  created (){
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchSubjects()
  },
  methods: {
    fetchSubjects(){
      getSubjects().then(response => {
        this.subjects = response.data.data
      })
    },
    handleAdd() {
      this.id = null;
      this.activeModal = true;
    },
    handleEdit(id) {
      this.id = id;
      this.activeModal = true;
    },
    modalClose(){
      this.activeModal = false
      this.fetchSubjects()
    },
    closeModal(){
      this.activeModal = false
    },
    getData(){
      this.activeModal = false
      this.fetchSubjects()
    },
    handleDelete(id) {
      if (id) {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            // eslint-disable-next-line no-unused-vars
            deleteSubject({ id }).then(res => {
              Swal.fire({
                icon: 'success',
                position: 'center',
                title: 'Deleted!',
                text: 'Your file has been deleted.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
              this.fetchSubjects()
            })
          } else if (result.dismiss === 'cancel') {
            Swal.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
      }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");
      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #4d63cf;
}
.bx{
  font-size: 19px;
}
</style>



